var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 7.16406V15.1641",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 4.4226L6.66797 7.16927H2.7813C2.57431 7.16927 2.37016 7.21746 2.18502 7.31003C1.99988 7.4026 1.83883 7.53701 1.71464 7.7026C1.59044 7.8682 1.5065 8.06044 1.46948 8.26409C1.43245 8.46774 1.44334 8.67722 1.5013 8.87594L3.05464 14.2093C3.13541 14.4862 3.30384 14.7295 3.53464 14.9026C3.76543 15.0757 4.04614 15.1693 4.33464 15.1693H13.3346C13.6883 15.1693 14.0274 15.0288 14.2774 14.7787C14.5275 14.5287 14.668 14.1896 14.668 13.8359V8.5026C14.668 8.14898 14.5275 7.80984 14.2774 7.5598C14.0274 7.30975 13.6883 7.16927 13.3346 7.16927H11.4946C11.2466 7.16914 11.0035 7.09981 10.7927 6.96908C10.5819 6.83836 10.4117 6.65141 10.3013 6.42927L8.0013 1.83594C7.68692 1.83983 7.37748 1.91472 7.0961 2.055C6.81472 2.19529 6.56868 2.39734 6.37637 2.64607C6.18405 2.8948 6.05042 3.18378 5.98548 3.49141C5.92053 3.79903 5.92594 4.11736 6.0013 4.4226Z",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.d24cfb4912fd26b4ce3efbc573e72ef1.svg";
export { ForwardRef as ReactComponent };